import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useNotification } from '../../../helpers/Notification';
import * as ROUTES from '../../../router/Routes';
import { LoadingWidget } from '../../../widgets';
import { getVistasLoginAction } from '../../auth/login/LoginAction';
import { USU_ENTIDAD_LOGIN } from '../../auth/login/LoginReducer';
import {
  allUsuEntidadesAction,
  setActivoUsuEntidadesAction,
} from '../../usuario/usu_entidades/UsuEntidadesAction';
import {
  oneEntidadesAction,
  setActivoEntidadesAction,
} from '../entidades/EntidadesAction';
import CardEntidades from '../entidades/components/CardEntidades';

const MisEntidadesView = () => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();
  let history = useHistory();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const usuEntidadesStore = Redux.useSelector((state) => state.usuEntidades);

  // const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    async function fetchData() {
      await setActivoEntidadesAction(dispatch, null);

      if (usuEntidadesStore.all.length === 0) {
        await allUsuEntidadesAction(dispatch, {
          idUsuario: loginStore.user.id,
        });
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return usuEntidadesStore.loadingAll ? (
    <LoadingWidget isLoading={usuEntidadesStore.loadingAll} />
  ) : (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12}>
        <LoadingWidget isLoading={loading} />
      </Grid>
      {usuEntidadesStore.all.map((el) => {
        return (
          <Grid item xs={12} sm={4}>
            <CardEntidades
              data={el}
              onPess={() => {}}
              activo={entidadesStore.activo}
              onAdmin={async () => {
                if (el.perfiles.length === 0) {
                  notify('No tiene perfiles asignados', { warning: true });
                  return;
                }
                setActivoEntidadesAction(dispatch, null);

                setLoading(true);
                await oneEntidadesAction(dispatch, el.entidad.id);
                await getVistasLoginAction(dispatch, {
                  rol: el.isInvitado
                    ? el.perfiles[0]?.perfil.rol
                    : loginStore.rol,
                  idUsuEntidad: el.id,
                });
                setLoading(false);
                setActivoUsuEntidadesAction(dispatch, el);
                dispatch({
                  type: USU_ENTIDAD_LOGIN,
                  payload: el.isInvitado ? el : null,
                });
                history.push(ROUTES.dashboard.to);
              }}
              // onDelete={async () => {
              //   setOpenModalDelete(true);
              //   setUsuEntidad(el);
              // }}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default MisEntidadesView;
